import { Routes } from '@angular/router';
import { NotFoundComponent } from './pages/other-page/not-found/not-found.component';
import { authGuard } from './shared/auth/auth.guard';
import { superAdminGuard } from './shared/auth/super-admin.guard';
import { unsavedChangesGuard } from './features/surveys/pages/survey-builder/survey-builder.guard';
import { surveySelectedGuard } from './features/surveys/guards/survey-selected.guard';

import { AppLayoutComponent } from './core/layout/app-layout/app-layout.component';
import { MainPageComponent } from './features/dashboard/pages/main-page/main-page.component';
import { ProfileComponent } from './features/user/pages/profile/profile.component';
import { SignInComponent } from './features/auth-pages/sign-in/sign-in.component';
import { SignUpComponent } from './features/auth-pages/sign-up/sign-up.component';
import { OrganizationsManagementComponent } from './features/organizations/pages/organizations-management/organizations-management.component';
import { SurveysManagementComponent } from './features/surveys/pages/surveys-management/surveys-management.component';
import { SurveyBuilderComponent } from './features/surveys/pages/survey-builder/survey-builder.component';
import { SurveyCmdComponent } from './features/surveys/pages/survey-cmd/survey-cmd.component';
import { SurveyTranslationsComponent } from './features/surveys/pages/survey-translations/survey-translations.component';
import { GlobalTranslationsComponent } from './features/surveys/pages/global-translations/global-translations.component';
import { EmailTranslationsComponent } from './features/surveys/pages/email-translations/email-translations.component';
import { TranslationsExportComponent } from './features/translations/pages/translations-export/translations-export.component';
import { TranslationsImportComponent } from './features/translations/pages/translations-import/translations-import.component';
import { EnvironmentDeltaComponent } from './features/release-management/pages/environment-delta/environment-delta.component';
import { SurveyBusinessRulesComponent } from './features/surveys/pages/survey-business-rules/survey-business-rules.component';
import { SurveyFieldworksComponent } from './features/surveys/pages/survey-fieldworks/survey-fieldworks.component';
import { SynchronizerComponent } from './features/release-management/pages/synchronizer/synchronizer.component';
import { SurveyAlertComponent } from './features/surveys/pages/survey-alert/survey-alert.component';
import { CustomerSearchComponent } from './features/reporting/pages/customer-search/customer-search.component';

export const routes: Routes = [
  {
    path:'',
    component:AppLayoutComponent,
    canActivateChild : [authGuard],
    children:[
      {
        path: '',
        component: MainPageComponent,
        pathMatch: 'full',
        title: 'Main Page | Survey Admin Panel',
      },
      {
        path:'organizations',
        component:OrganizationsManagementComponent,
        title:'Organizations | Survey Admin Panel'
      },
      {
        path:'surveys',
        component:SurveysManagementComponent,
        title:'Surveys | Survey Admin Panel'
      },
      {
        path: 'surveys/global-translations',
        component: GlobalTranslationsComponent,
        title:'Global Translations | Survey Admin Panel',
        canDeactivate: [unsavedChangesGuard]
      },
      {
        path: 'surveys/email-translations',
        component: EmailTranslationsComponent,
        title:'Email Translations | Survey Admin Panel',
        canDeactivate: [unsavedChangesGuard]
      },
      {
        path: 'surveys/:id/builder',
        component: SurveyBuilderComponent,
        title:'Survey Builder | Survey Admin Panel',
        canActivate: [surveySelectedGuard],
        canDeactivate: [unsavedChangesGuard]
      },
      {
        path: 'surveys/:id/translations',
        component: SurveyTranslationsComponent,
        title:'Survey Translations | Survey Admin Panel',
        canActivate: [surveySelectedGuard],
        canDeactivate: [unsavedChangesGuard]
      },
      {
        path: 'surveys/:id/cmd',
        component: SurveyCmdComponent,
        title:'Survey CMD | Survey Admin Panel',
        canActivate: [surveySelectedGuard],
        canDeactivate: [unsavedChangesGuard]
      },
      {
        path: 'surveys/:id/fieldworks',
        component: SurveyFieldworksComponent,
        title:'Survey Fieldworks | Survey Admin Panel',
        canActivate: [surveySelectedGuard]
      },
      {
        path: 'surveys/:id/businessrules',
        component: SurveyBusinessRulesComponent,
        title:'Survey Business Rules | Survey Admin Panel',
        canActivate: [surveySelectedGuard],
        canDeactivate: [unsavedChangesGuard]
      },
      {
        path: 'surveys/:id/alert',
        component: SurveyAlertComponent,
        title:'Survey Alert | Survey Admin Panel',
        canActivate: [surveySelectedGuard],
        canDeactivate: [unsavedChangesGuard]
      },
      {
        path:'translations/export',
        component: TranslationsExportComponent,
        title:'Translations Export | Survey Admin Panel'
      },
      {
        path:'translations/import',
        component: TranslationsImportComponent,
        title:'Translations Import | Survey Admin Panel'
      },
      {
        path:'release-management/envdelta',
        component: EnvironmentDeltaComponent,
        title:'Environment Delta | Survey Admin Panel',
        canActivate: [superAdminGuard]
      },
      {
        path:'release-management/synchronizer',
        component: SynchronizerComponent,
        title:'Synchronizer | Survey Admin Panel',
        canActivate: [superAdminGuard]
      },
      {
        path:'user/profile',
        component:ProfileComponent,
        title:'User Profile | Survey Admin Panel'
      },
      {
        path:'reporting/customer-search',
        component: CustomerSearchComponent,
        title:'Customer Search | Survey Admin Panel'
      }
    ]
  },
  // auth pages
  {
    path:'signin',
    component:SignInComponent,
    title:'Angular Sign In Dashboard | Survey Admin Panel'
  },
  {
    path:'signup',
    component:SignUpComponent,
    title:'Angular Sign Up Dashboard | Survey Admin Panel'
  },
  // error pages
  {
    path:'**',
    component:NotFoundComponent,
    title:'Angular NotFound Dashboard | Survey Admin Panel'
  },
];
